import angular from 'angular';
import cannotSignupModalComponent from './cannotSignupModal.component';

let cannotSignupModalModule = angular.module('cannotSignupModal', [])

.component('cannotSignupModal', cannotSignupModalComponent)

.name;

export default cannotSignupModalModule;



// WEBPACK FOOTER //
// ./client/app/components/cannotSignupModal/cannotSignupModal.js